import {ResearchTitle} from "../const";


export class ResearchTemplate {
  constructor(totalResearches, mode) {
    // super();

    this._totalResearches = totalResearches;
    this._mode = mode || ``;
  }

  getTemplate() {
    const totalResearches = this._totalResearches;
    const mode = this._mode;
    const totlalAmount = totalResearches.reduce((accumulator, researchItem) => accumulator + researchItem.totalAmount, 0);
    const totlalAmountTitle = mode ? `Общее количество исследований` : `Общее количество<br/>исследований`;
    const researchTemplates = [];

    totalResearches.forEach((research) => {
      const researchTitle = ResearchTitle[research.name].title;
      const researchAmount = research.totalAmount;
      const researchTitleNotMatch = ResearchTitle[research.name].titleNotMatch;
      const researchAmountNotMatch = research.totalAmountNotMatch;

      researchTemplates.push(`
        <tr class="research__data  ${mode && `research__data--${mode}`}">
          <td class="research__description  ${mode && `research__description--${mode}`}">${researchTitle}</td>
          <td class="research__amount  ${mode && `research__amount--${mode}`}">${researchAmount}</td>
        </tr>
        <tr class="research__data-not-match  ${mode && `research__data-not-match--${mode}`}">
          <td class="research__description  ${mode && `research__description--${mode}`}">${researchTitleNotMatch}</td>
          <td class="research__amount  ${mode && `research__amount--${mode}`}">${researchAmountNotMatch}</td>
        </tr>
      `);
    });

    return (
      `<div class="research  ${mode && `research--${mode}`}">
        <div class="research__wrapper  ${mode && `research__wrapper--${mode}`}">
          <table class="research__info  ${mode && `research__info--${mode}`}">
            <tbody>
              <tr class="research__head  ${mode && `research__head--${mode}`}">
                <th class="research__description  ${mode && `research__description--${mode}`}">${totlalAmountTitle}</th>
                <th class="research__amount  ${mode && `research__amount--${mode}`}">${totlalAmount}</th>
              </tr>

              ${researchTemplates.join(``)}
            </tbody>
          </table>
        </div>
      </div>`
    );
  }
}
